module.exports = __webpack_public_path__ + "img/rings.828d83a3.svg";